import { GetSharepointSheetTabTitlesAction } from 'constants/BackgroundScript';

/**
 * Reads worksheet tab labels from Excel Online’s sheet strip (DOM in excel.officeapps frames).
 * Side panel → service worker → `listExcelSheetTabTitlesFromDom`.
 */
export async function getSharepointSheetTabTitlesForHostTab(
  hostTabId: number
): Promise<string[]> {
  if (typeof chrome === 'undefined' || !chrome.runtime?.sendMessage) {
    return [];
  }
  return new Promise((resolve) => {
    try {
      chrome.runtime.sendMessage(
        {
          action: GetSharepointSheetTabTitlesAction,
          tabId: hostTabId,
        },
        (response: { success?: boolean; titles?: string[] }) => {
          if (chrome.runtime.lastError) {
            resolve([]);
            return;
          }
          if (!response?.success || !Array.isArray(response.titles)) {
            resolve([]);
            return;
          }
          resolve(response.titles);
        }
      );
    } catch {
      resolve([]);
    }
  });
}
